import { Routes as Switch, Route } from "react-router-dom";
import MasterPage from "../Layout/MasterPage";
import CustomerRouteGuard from "./CustomerRouteGuard";
import SahraConnections from "../Pages/Sahra/SahraConnections";
import SahraUsers from "../Pages/Sahra/SahraUsers";
import NotFound from "../Pages/NotFound";
import OrderBook from "../Pages/OrderBookSample/OrderBookSample";
import Portfolio from "../Pages/Porfolio/Portfolio";
import Step from "../Pages/Step/Step";
import InsSettings from "../Pages/InsSettings/InsSettings";
import SiteUserManager from "../Pages/SiteUserManager/SiteUserManager";
import RolesAndPermissions from "../Pages/RolesAndPermissions/RolesAndPermissions";
import SahraUserGroups from "../Pages/SahraUserGroups/SahraUserGroups";
import Manual from "../Pages/Manual/Manual";
import Strategy from "../Pages/Strategy/Strategy";
import Freeze from "../Pages/Freeze/Freeze";
// Market Watch
import OptionGreek from "../Pages/OptionGreek/OptionGreek";
import Synthetic from "../Pages/MarketWatchSynthetic/MarketWatchSynthetic";
import DeltaHedgeSettings from "../Pages/DeltaHedgeSettings/DeltaHedgeSettings";
import DeltaHedgeAccounts from "../Pages/DeltaHedgeAccounts/DeltaHedgeAccounts";
import OptionDomain from "../Pages/OptionDomain/OptionDomain";
import DeltaHedgeExe from "../Pages/DeltaHedgeExe/DeltaHedgeExe";
import Conversion from "../Pages/Conversion/Conversion";
import NLegs from "../Pages/NLegs/NLegs";
import Kamin2Leg from "../Pages/Kamin2Leg/Kamin2Leg";
import Marketmaking from "../Pages/Marketmaking/Marketmaking";
import DeltaHedgeMarketmaking from "../Pages/DeltaHedgeMarketmaking/Marketmaking";
import ApplyOption from "../Pages/ApplyOption/ApplyOption";
import Addressbook from "../Pages/Addressbook/Addressbook";
import UploadAll from "../Pages/UploadAll/UploadAll";
import Setting from "../Pages/Setting/Setting";
import DeltaHedgeExePhase3 from "../Pages/DeltaHedgeExePhase3/DeltaHedgeExePhase3";
import DeltaHedgeOrder from "../Pages/DeltaHedgeOrder/DeltaHedgeOrder";
// اتصال کاربران
import UserConnections from "../Pages/Connections/UserConnections";
// عملیات
import FundNoRisk from "../Pages/FundNoRisk/FundNoRisk";
//  یازارگردانی
import AutomaticMarketMaking from "../Pages/AutomaticMarketMaking/AutomaticMarketMaking";
import BaseMarketMaking from "../Pages/BaseMarketMaking/BaseMarketMaking";
import FuturesMarketMaking from "../Pages/FuturesMarketMaking/FuturesMarketMaking";
import History from "src/Pages/History/History";
import Logs from "src/Pages/Logs/Logs";
// Covered Call
import CoveredCall from "src/Pages/CoveredCall/CoveredCall";
import DeltaHedgeBackTest from "src/Pages/DeltaHedgeBackTest";
// IMEMarketWatch
import IMEMarketWatch from "src/Pages/IMEMarketWatch/IMEMarketWatch";
import IMEPortfolio from "src/Pages/IMEPortfolio/Portfolio";
import GoldArbitrage from "src/Pages/GoldArbitrage/GoldArbitrage";
// مانیتورینگ پورتفو
import PortfoMonitoring from "src/Pages/PortfoMonitoring/PortfoMonitoring";
import CCOrder from "src/Pages/CCOrder";
import Collateral from "src/Pages/Collateral";
// گروهبندی پورتفو
import PortfolioGroups from "src/Pages/PortfolioGroups";
import GroupingSettings from "src/Pages/GroupingSettings";
// طبقه‌بندی دارایی
import AssetClass from "src/Pages/AssetClass";
import MarketHistory from "src/Pages/MarketHistory";
import SystemParameters from "src/Pages/SystemParameters";
// تقویم کاری
import WorkingCalender from "src/Pages/DateAndTime/WorkingCalender";
// لینک گزارش کاربران
import ReportLinks from "src/Pages/ReportLinks";
import MarketTradeHour from "src/Pages/DateAndTime/MarketTradeHour";
import DateAndTime from "src/Pages/DateAndTime";
import CoveredMatrixOrder from "src/Pages/CoveredMatrixOrder/CoveredMatrixOrder";
import WorkerHostPermission from "src/Pages/OperationSettings/WorkerHostPermission";

const AfterAuthRoutes = () => {
  return (
    <MasterPage>
      <CustomerRouteGuard>
      <Switch>
        <Route path="/sahra_user/*" element={<SahraUsers />} />
        <Route path="/sahra_connections" element={<SahraConnections />} />
        <Route path="/userConnections" element={<UserConnections />} />
        <Route path="/order_book" element={<OrderBook />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/step" element={<Step />} />
        <Route path="/ins_Settings" element={<InsSettings />} />
        <Route path="/siteUserManager" element={<SiteUserManager />} />
        <Route path="/rolesAndPermissions" element={<RolesAndPermissions />} />
        <Route path="/sahraUserGroups" element={<SahraUserGroups />} />
        <Route path="/manual" element={<Manual />} />
        <Route path="/strategy" element={<Strategy />} />
        <Route path="/freeze" element={<Freeze />} />
        <Route path="/history" element={<History />} />

        {/** Market Watch */}
        <Route path="/optionGreek" element={<OptionGreek />} />
        <Route path="/synthetic" element={<Synthetic />} />
        <Route path="/deltaHedgeSettings" element={<DeltaHedgeSettings />} />
        <Route path="/deltaHedgeAccounts" element={<DeltaHedgeAccounts />} />
        <Route path="/deltaHedgeExe" element={<DeltaHedgeExe />} />
        <Route path="/deltaHedgeExePhase3" element={<DeltaHedgeExePhase3 />} />
        <Route path="/deltaHedgeBackTest" element={<DeltaHedgeBackTest />} />
        <Route path="/optionDomain" element={<OptionDomain />} />
        <Route path="/conversion" element={<Conversion />} />
        <Route path="/kamin2leg" element={<Kamin2Leg />} />
        <Route path="/nLegs" Component={() => <NLegs legCount={3} />} />
        <Route path="/fourLegs" Component={() => <NLegs legCount={4} />} />
        <Route path="/twoLegs" Component={() => <NLegs legCount={2} />} />
        <Route path="/marketmaking" element={<Marketmaking />} />
        <Route
          path="/deltaHedgeMarketmaking"
          element={<DeltaHedgeMarketmaking />}
        />
        <Route path="/applyOption" element={<ApplyOption />} />
        <Route path="/addressbook" element={<Addressbook />} />
        <Route path="/uploadAll" element={<UploadAll />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/deltaHedgeOrder" element={<DeltaHedgeOrder />} />
        {/** عملیات */}
        <Route path="/fixedIncome" element={<FundNoRisk />} />
        <Route path="/systemParameters" element={<SystemParameters />} />
        {/** یازارگردانی  */}
        <Route
          path="/automaticMarketMaking"
          element={<AutomaticMarketMaking />}
        />
        <Route path="/baseMarketMaking" element={<BaseMarketMaking />} />
        <Route path="/futuresMarketMaking" element={<FuturesMarketMaking />} />
        <Route path="/iMEMarketWatch" element={<IMEMarketWatch />} />
        <Route path="/iMEPortfolio" element={<IMEPortfolio />} />
        <Route path="/goldArbitrage" element={<GoldArbitrage />} />
        <Route path="/logs" element={<Logs />} />
        {/** covered call  */}
        <Route path="/coveredCall" element={<CoveredCall />} />

        <Route path="/coveredCallOrder" element={<CCOrder />} />
        <Route path="/CoveredMatrixOrder" element={<CoveredMatrixOrder />} />
        {/** مانیتورینگ پورتفو */}
        <Route path="/portfoMonitoring" element={<PortfoMonitoring />} />

        <Route path="/collateral" element={<Collateral />} />
        {/** گروهبندی پورتفو */}
        <Route path="/portfolioGroups" element={<PortfolioGroups />} />
        <Route path="/groupingSettings" element={<GroupingSettings />} />
        {/** طبقه‌بندی دارایی */}
        <Route path="/assetClass" element={<AssetClass />} />
        <Route path="/marketHistory" element={<MarketHistory />} />
        {/**لینک گزارش اختصاصی کاربران */}
        <Route path="/reportLinks" element={<ReportLinks />} />
        {/** تقویم کاری */}
        <Route path="/DateAndTime" element={<DateAndTime />} />
        <Route
          path="/OperationSettings/WorkerHostPermission"
          element={<WorkerHostPermission />}
        />

        <Route path="/*" element={<NotFound />} />
      </Switch>
      </CustomerRouteGuard>
    </MasterPage>
  );
};

export default AfterAuthRoutes;
